import React, { useCallback } from 'react';

import type { RemixContentComponentProps } from '@atlassian/editor-plugin-malleable-ui';
import { RemixContainer } from '@atlassian/malleable-ui-components';

import { ConfluenceConversationAssistant } from '@confluence/conversation-assistant/entry-points/main.ts';

import { useRemixToAIFC } from './useRemixToAIFC.ts';

/**
 * Creates a content component for RemixContentComponent using RemixContainer.
 */
export const createRemixContentComponent = () => {
	const Component = ({ handleModalClose, selectedContext }: RemixContentComponentProps) => {
		const { openAIFCStagingWithPrompt } = useRemixToAIFC();

		const onOptionSelect = useCallback(
			(type: string) => {
				handleModalClose();
				void openAIFCStagingWithPrompt(selectedContext.selectionMarkdown || '', type);
			},
			[handleModalClose, openAIFCStagingWithPrompt, selectedContext.selectionMarkdown],
		);

		return (
			<RemixContainer
				selectedText={selectedContext.selectionMarkdown || ''}
				onClose={handleModalClose}
				onOptionSelect={onOptionSelect}
			/>
		);
	};

	const Wrapper = (props: RemixContentComponentProps) => {
		return props.isModalOpen ? (
			<ConfluenceConversationAssistant>
				<Component {...props} />
			</ConfluenceConversationAssistant>
		) : null;
	};

	return Wrapper;
};
